let intervals = [];

const countdown = (endTime) => {
  const now = new Date();
  const timeLeft = endTime - now;

  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
  const seconds = Math.floor((timeLeft / 1000) % 60);

  return {
    days: days < 10 ? `0${days}` : days,
    hours: hours < 10 ? `0${hours}` : hours,
    minutes: minutes < 10 ? `0${minutes}` : minutes,
    seconds: seconds < 10 ? `0${seconds}` : seconds,
  };
};

const updateCountdown = (section) => {
  let date = moment.tz(section.data("finish-time").replace(/-/g, "/"), "Europe/Madrid").subtract(1,'hours');
  //let date = new Date(section.data("finish-time").replace(/-/g, "/"));
  if (date > new Date()) {
    const { days, hours, minutes, seconds } = countdown(
      moment.tz(section.data("finish-time").replace(/-/g, "/"), "Europe/Madrid").subtract(1,'hours')
      //new Date(section.data("finish-time").replace(/-/g, "/"))
    );
    section.find(".days .number").text(days);
    section.find(".hours .number").text(hours);
    section.find(".minutes .number").text(minutes);
    section.find(".seconds .number").text(seconds);
  } else {
    section.find(".countdown").css("display", "none");
  }
};

const initCountdown = (slideshowSection) => {
  $(slideshowSection).each(function (index) {
    let sectionSlideshowCountdown = $(this).find(".slideshow-countdown").eq(0);
    let slick = $(this).find(".slick-list").eq(0);
    if (sectionSlideshowCountdown.length) {
      $(sectionSlideshowCountdown).insertAfter(slick);
      updateCountdown(sectionSlideshowCountdown);
      intervals.push(setInterval(() => updateCountdown(sectionSlideshowCountdown), 1000));
    }    
  });
}

$(document).ready(function () {
  setTimeout(() => {
    initCountdown($(".section-slideshow"));
  }, 1000);
});

$(window).on("shopify:section:load", function ({ target }) {
  for (let i = 0; i < intervals.length; i++) {
    clearInterval(intervals[i]);
  }
  intervals = [];
  initCountdown($(".section-slideshow"));
});
